<div class="modal-container force-landscap">
  <div class="modal-wrapper">
    <button class="close-button" (click)="close()">×</button>
    <div class="modal-content">
      <div class="top-chip">{{'escanear_codigo_barras' | transloco}}</div>

      <div class="scan-line"></div>
      <!-- CANTOS -->
      <div class="corner top-left"></div>
      <div class="corner top-right"></div>
      <div class="corner bottom-left"></div>
      <div class="corner bottom-right"></div>
      <div class="bottom-chip" style="display:none;"></div>
      <zxing-scanner [formats]="allowedFormats" (scanSuccess)="onScanSuccess($event)" (scanError)="onScanError($event)"
        (camerasFound)="onCamerasFound($event)" (permissionResponse)="onPermissionResponse($event)">
      </zxing-scanner>
    </div>
  </div>
</div>
